import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.2,
        });

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        const id = requestAnimationFrame(raf);

        // Smooth scroll for anchor links
        const handler = (e) => {
            const target = e.target.closest("a[href^='#']");
            if (!target) return;
            const id = target.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (!el) return;
            e.preventDefault();
            lenis.scrollTo(el, { offset: -80, duration: 1.4 });
        };
        document.addEventListener("click", handler);

        return () => {
            cancelAnimationFrame(id);
            document.removeEventListener("click", handler);
            lenis.destroy();
        };
    }, []);
    return null;
}
